import { CopyIcon } from "lucide-react";

export function QuestionAnswerFlashcardToolbarIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.32679 11.67H2.67V14.835C2.67 16.1218 3.71318 17.165 5 17.165H13C14.2868 17.165 15.33 16.1218 15.33 14.835V12.9898L15.9088 10.7452L17 10.464V10.835V11.67V14.835C17 17.0441 15.2091 18.835 13 18.835H5C2.79086 18.835 1 17.0441 1 14.835V11.67V10.835V9.99996V6.83496C1 4.62582 2.79086 2.83496 5 2.83496H9.36954L9.0887 3.92405L6.83736 4.50496H5C3.71318 4.50496 2.67 5.54814 2.67 6.83496V9.99996H6.1988L9.08846 10.7451L9.32679 11.67Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4993 1C12.2571 1 12.0215 1.07925 11.8285 1.22565C11.6355 1.37205 11.4957 1.57757 11.4304 1.81085L11.426 1.82739L10.556 5.20102C10.5442 5.24678 10.5202 5.2887 10.4868 5.32212C10.4533 5.35557 10.4115 5.37945 10.3656 5.39127L6.99132 6.26194L6.97195 6.26719C6.73959 6.33314 6.53508 6.47308 6.38945 6.6658C6.24383 6.85851 6.16504 7.09346 6.16504 7.335C6.16504 7.57654 6.24383 7.81149 6.38945 8.0042C6.53508 8.19691 6.73959 8.33686 6.97195 8.40281L6.99145 8.40809L10.3655 9.27815C10.4114 9.28998 10.4532 9.31388 10.4867 9.34736C10.5201 9.38079 10.544 9.42256 10.5559 9.46832L11.4254 12.8425L11.4299 12.8592C11.4951 13.0924 11.635 13.298 11.8279 13.4444C12.0209 13.5907 12.2565 13.67 12.4988 13.67C12.741 13.67 12.9766 13.5907 13.1696 13.4444C13.3626 13.2979 13.5024 13.0924 13.5677 12.8592L13.5722 12.8426L14.4422 9.46853C14.454 9.42272 14.478 9.38082 14.5114 9.34736C14.5449 9.31388 14.5867 9.28998 14.6326 9.27815L18.0065 8.40868L18.0202 8.40503C18.2544 8.34043 18.4609 8.20077 18.6081 8.00748C18.7553 7.81419 18.835 7.57795 18.835 7.335C18.835 7.09205 18.7553 6.8558 18.6081 6.66252C18.4609 6.46923 18.2544 6.32957 18.0202 6.26497L14.6326 5.39185C14.5183 5.36239 14.458 5.25265 14.4422 5.20147L13.5727 1.82751L13.5683 1.81085C13.503 1.57757 13.3632 1.37205 13.1702 1.22565C12.9772 1.07925 12.7416 1 12.4993 1ZM12.8251 5.61842L12.4992 4.35364L12.1728 5.61908C12.0863 5.95372 11.9117 6.25907 11.6672 6.5034C11.4228 6.74768 11.1172 6.92208 10.7826 7.00839L10.5559 7.06686L9.51744 7.33483L10.5559 7.60262L10.7827 7.66109C11.1175 7.74747 11.4231 7.92199 11.6676 8.16649C11.6994 8.19828 11.73 8.23111 11.7594 8.2649C11.956 8.491 12.0979 8.76029 12.173 9.05158L12.499 10.3164L12.8251 9.05137C12.9115 8.71655 13.086 8.41099 13.3305 8.16649C13.575 7.92199 13.8808 7.74741 14.2156 7.66104L15.4808 7.335L14.2154 7.00891C13.9242 6.93377 13.6551 6.79193 13.429 6.59535C13.3952 6.56595 13.3624 6.53532 13.3305 6.50351C13.086 6.259 12.9115 5.95324 12.8251 5.61842Z"
      />
    </svg>
  );
}

export function ManualFlashcardToolbarIcon() {
  return (
    <>
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.17 15.17H3.83c-1.66 0-3-1.34-3-3V3.83C.83 2.18 2.18.83 3.83.83h8.33c1.66 0 3 1.34 3 3v8.33c0 1.66-1.34 3-3 3Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.67"
        />
        <line
          x1="15.17"
          y1="8"
          x2=".83"
          y2="8"
          stroke="currentColor"
          strokeWidth="1.67"
        />
      </svg>
    </>
  );
}

export function ClozeDeletionToolbarIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91709 14.0936C9.91709 14.6347 9.47846 15.0733 8.93737 15.0733H6.87487C6.33378 15.0733 5.89513 14.6347 5.89513 14.0936V7.90612C5.89513 7.36503 6.33378 6.92638 6.87487 6.92638H8.93737C9.47846 6.92638 9.91709 7.36503 9.91709 7.90612C9.91709 8.44721 9.47846 8.88584 8.93737 8.88584H7.85459V13.1139H8.93737C9.47846 13.1139 9.91709 13.5525 9.91709 14.0936ZM8.61022 11C8.61022 10.4589 9.04886 10.0203 9.58995 10.0203H12.4455C12.9866 10.0203 13.4252 10.4589 13.4252 11C13.4252 11.5411 12.9866 11.9798 12.4455 11.9798H9.58995C9.04886 11.9798 8.61022 11.5411 8.61022 11ZM12.0826 7.90612C12.0826 7.36503 12.5213 6.92638 13.0624 6.92638H15.1249C15.666 6.92638 16.1046 7.36503 16.1046 7.90612V14.0936C16.1046 14.6347 15.666 15.0733 15.1249 15.0733H13.0624C12.5213 15.0733 12.0826 14.6347 12.0826 14.0936C12.0826 13.5525 12.5213 13.1139 13.0624 13.1139H14.1451V8.88584H13.0624C12.5213 8.88584 12.0826 8.44721 12.0826 7.90612ZM16.8603 11C16.8603 10.4589 17.2989 10.0203 17.8399 10.0203L17.8406 6.89334C17.8406 5.38346 16.6165 4.15946 15.1066 4.15946H6.89334C5.38347 4.15946 4.15946 5.38347 4.15946 6.89334V10.0203H4.4337C4.97479 10.0203 5.41344 10.4589 5.41344 11C5.41344 11.5411 4.97479 11.9798 4.4337 11.9798H4.15946V15.1066C4.15946 16.6165 5.38346 17.8406 6.89334 17.8406H15.1066C16.6165 17.8406 17.8406 16.6165 17.8406 15.1066V11.9798C17.2995 11.9798 16.8603 11.5411 16.8603 11ZM6.89334 2.2C4.30128 2.2 2.2 4.30128 2.2 6.89334V15.1066C2.2 17.6987 4.30128 19.8 6.89334 19.8H15.1066C17.6987 19.8 19.8 17.6987 19.8 15.1066V6.89334C19.8 4.30128 17.6987 2.2 15.1066 2.2H6.89334Z"
      />
    </svg>
  );
}

export function TermsToolbarIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73433 6.6875C6.73433 6.1956 7.1331 5.79683 7.625 5.79683H12.3125C12.8044 5.79683 13.2032 6.1956 13.2032 6.6875C13.2032 7.1794 12.8044 7.57817 12.3125 7.57817H7.625C7.1331 7.57817 6.73433 7.1794 6.73433 6.6875ZM4.39058 12.3125C4.39058 11.8206 4.78935 11.4218 5.28125 11.4218H14.6562C15.1482 11.4218 15.5469 11.8206 15.5469 12.3125V14.6562C15.5469 15.1482 15.1482 15.5469 14.6562 15.5469H5.28125C4.78935 15.5469 4.39058 15.1482 4.39058 14.6562V12.3125ZM16.2187 9.10933V6.26667C16.2187 4.89405 15.1059 3.78133 13.7333 3.78133H6.26667C4.89406 3.78133 3.78133 4.89406 3.78133 6.26667V9.10933H16.2187ZM3.78133 10.8907H16.2187V13.7333C16.2187 15.1059 15.1059 16.2187 13.7333 16.2187H6.26667C4.89405 16.2187 3.78133 15.1059 3.78133 13.7333V10.8907ZM6.17192 13.2032V13.7656H13.7656V13.2032H6.17192ZM6.26667 2C3.91025 2 2 3.91025 2 6.26667V13.7333C2 16.0897 3.91025 18 6.26667 18H13.7333C16.0897 18 18 16.0897 18 13.7333V6.26667C18 3.91025 16.0897 2 13.7333 2H6.26667Z"
      />
    </svg>
  );
}

export function MultipleChoiceToolbarIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.39058 6.6875C4.39058 6.1956 4.78935 5.79683 5.28125 5.79683H14.6562C15.1482 5.79683 15.5469 6.1956 15.5469 6.6875C15.5469 7.1794 15.1482 7.57817 14.6562 7.57817H5.28125C4.78935 7.57817 4.39058 7.1794 4.39058 6.6875ZM4.39058 12.3125C4.39058 11.8206 4.78935 11.4218 5.28125 11.4218H9.03125C9.52315 11.4218 9.92192 11.8206 9.92192 12.3125C9.92192 12.8044 9.52315 13.2032 9.03125 13.2032H5.28125C4.78935 13.2032 4.39058 12.8044 4.39058 12.3125ZM10.0156 12.3125C10.0156 11.8206 10.4143 11.4218 10.9062 11.4218H14.6562C15.1482 11.4218 15.5469 11.8206 15.5469 12.3125C15.5469 12.8044 15.1482 13.2032 14.6562 13.2032H10.9062C10.4143 13.2032 10.0156 12.8044 10.0156 12.3125ZM4.39058 14.6562C4.39058 14.1643 4.78935 13.7656 5.28125 13.7656H9.03125C9.52315 13.7656 9.92192 14.1643 9.92192 14.6562C9.92192 15.1482 9.52315 15.5469 9.03125 15.5469H5.28125C4.78935 15.5469 4.39058 15.1482 4.39058 14.6562ZM10.0156 14.6562C10.0156 14.1643 10.4143 13.7656 10.9062 13.7656H14.6562C15.1482 13.7656 15.5469 14.1643 15.5469 14.6562C15.5469 15.1482 15.1482 15.5469 14.6562 15.5469H10.9062C10.4143 15.5469 10.0156 15.1482 10.0156 14.6562ZM16.2187 9.10933V6.26667C16.2187 4.89405 15.1059 3.78133 13.7333 3.78133H6.26667C4.89406 3.78133 3.78133 4.89406 3.78133 6.26667V9.10933H16.2187ZM3.78133 10.8907H16.2187V13.7333C16.2187 15.1059 15.1059 16.2187 13.7333 16.2187H6.26667C4.89405 16.2187 3.78133 15.1059 3.78133 13.7333V10.8907ZM6.26667 2C3.91025 2 2 3.91025 2 6.26667V13.7333C2 16.0897 3.91025 18 6.26667 18H13.7333C16.0897 18 18 16.0897 18 13.7333V6.26667C18 3.91025 16.0897 2 13.7333 2H6.26667Z"
      />
    </svg>
  );
}

export function AIExplainToolbarIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 13.6667C19 14.1382 18.8127 14.5903 18.4793 14.9237C18.1459 15.2571 17.6937 15.4444 17.2222 15.4444H6.55556L3 19V4.77778C3 4.30628 3.1873 3.8541 3.5207 3.5207C3.8541 3.1873 4.30628 3 4.77778 3H17.2222C17.6937 3 18.1459 3.1873 18.4793 3.5207C18.8127 3.8541 19 4.30628 19 4.77778V13.6667Z"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8958 7.44531H6.5625"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4514 11H6.5625"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AIChatToolbarIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.776 8.33355C12.776 8.80505 12.5887 9.25723 12.2553 9.59063C11.9219 9.92403 11.4698 10.1113 10.9983 10.1113H5.66493L2.10938 13.6669V3.88911C2.10938 2.91133 2.90937 2.11133 3.88715 2.11133H10.9983C11.4698 2.11133 11.9219 2.29863 12.2553 2.63203C12.5887 2.96543 12.776 3.41761 12.776 3.88911V8.33355Z"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3377 8.33398H18.1155C18.5869 8.33398 19.0391 8.52129 19.3725 8.85468C19.7059 9.18808 19.8932 9.64027 19.8932 10.1118V19.8895L16.3377 16.334H11.0043C10.5328 16.334 10.0807 16.1467 9.74726 15.8133C9.41386 15.4799 9.22656 15.0277 9.22656 14.5562V13.6673"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NoteToolbarIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2462 2.11133H5.6684C5.19691 2.11133 4.74472 2.29863 4.41132 2.63203C4.07793 2.96543 3.89063 3.41761 3.89062 3.88911V18.1113C3.89063 18.5828 4.07793 19.035 4.41132 19.3684C4.74472 19.7018 5.19691 19.8891 5.6684 19.8891H16.3351C16.8066 19.8891 17.2587 19.7018 17.5921 19.3684C17.9255 19.035 18.1128 18.5828 18.1128 18.1113V11.5336"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.10938 5.66797H5.66493"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.10938 9.22266H5.66493"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.10938 12.7773H5.66493"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.10938 16.334H5.66493"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3351 5.33457C19.6892 4.98048 19.8881 4.50022 19.8881 3.99946C19.8881 3.4987 19.6892 3.01844 19.3351 2.66435C18.981 2.31026 18.5008 2.11133 18 2.11133C17.4992 2.11133 17.019 2.31026 16.6649 2.66435L12.2116 7.11946C12.0002 7.33068 11.8455 7.59176 11.7618 7.87857L11.0178 10.4297C10.9955 10.5062 10.9941 10.5872 11.0139 10.6644C11.0337 10.7416 11.0738 10.8121 11.1302 10.8684C11.1865 10.9247 11.257 10.9649 11.3341 10.9847C11.4113 11.0044 11.4924 11.0031 11.5689 10.9808L14.12 10.2368C14.4068 10.153 14.6679 9.99835 14.8791 9.78702L19.3351 5.33457Z"
        stroke="#525252"
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CopyTextToolbarIcon({
  className = "",
}: {
  className?: string;
}) {
  return <CopyIcon className={className} />;
}
